export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
};

export const algoliaConfig = {
  apiKey: import.meta.env.VITE_ALGOLIA_API_KEY,
  appId: import.meta.env.VITE_ALGOLIA_APP_ID,
  deudoresIndex: import.meta.env.VITE_ALGOLIA_DEUDORES_INDEX,
  clientsIndex: import.meta.env.VITE_ALGOLIA_CLIENTS_INDEX,
};

export const gtmConfig = { containerId: import.meta.env.VITE_GTM_CONTAINER_ID };
